module.exports = __webpack_public_path__ + "static/media/Trust-Badge-3.02cec2bb.png";